<template>
  <div class="py-3">
    <p class="mb-1">Coordinate</p>
    <p class="d-inline-block px-3 py-2 rounded text-white bg-secondary">
      {{ Helper.formatCoordinate([pavementData.lat, pavementData.lng]) }}
    </p>

    <p class="mb-0">Road Owners</p>
    <div class="mb-3">
      <div
        class="badge bg-secondary text-white fs-6 fw-normal mb-2 me-2 px-3 py-2"
        v-for="owner in Helper.pavementRoadOwners(pavementData).split(',')"
      >
        {{ owner }}
      </div>
    </div>

    <p class="mb-0">Roads</p>
    <div class="mb-3">
      <div
        class="badge bg-secondary text-white fs-6 fw-normal mb-2 me-2 px-3 py-2"
        v-for="road in Helper.pavementRoadNames(pavementData, {
          includeOwner: true,
          showAll: true,
        }).split(',')"
      >
        {{ road }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["componentId", "pavementData"],
  data() {
    return {
      siteVisitId: null,
    };
  },
  methods: {
    openMediaPreview(media) {
      this.$emit("open-media-preview", media);
    },
  },
  mounted() {
    this.siteVisitId = this.componentId;
  },
};
</script>